import React, { Children } from "react";
import { Flex } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { rowContainer } from "./styles_vanilla.css";

type MultiInputFormRowProps = {
  children: React.ReactElement[];
};

/**
 * A component that represents a row with two input fields in a form.
 *
 * @component
 * @example
 * ```tsx
 * <MultiInputFormRow>
 *   <InputField label="First Name" />
 *   <InputField label="Last Name" />
 * </MultiInputFormRow>
 * ```
 */
export const MultiInputFormRow: React.FC<MultiInputFormRowProps> = ({ children }) => {
  const childrenArray = Children.toArray(children);

  return (
    <Flex flexDirection={"row"} alignItems="flex-start" className={rowContainer} gap={Sizes.LG}>
      {childrenArray.map((child, index) => (
        <Flex key={index} flexDirection="column" flexGrow={1} flexBasis={0}>
          {child}
        </Flex>
      ))}
    </Flex>
  );
};
